import React from "react";

import GoogleAuthButton from "../GoogleAuthButton";

const GoogleLoginButton = () => (
    <GoogleAuthButton
        buttonAttrs={{
            "data-text": "signin_with",
            "data-testid": "google-login-button"
        }}
    />
);

export default GoogleLoginButton;
